import BaseTournamentController from '../baseTournamentController';
import {
  OP_WRAPPER_TOURNAMENTS_LOCALIZATION_PREFIX
} from '../../../../../utils/constants';

export default class ControllerRulesView extends BaseTournamentController {
  constructor(props) {
    super(props);

    this._eElementsTypes = {
      EET_TEXT_CONTAINER: 'text_container',
    };
    this._localizations = {
      [this._eElementsTypes.EET_TEXT_CONTAINER]: `${OP_WRAPPER_TOURNAMENTS_LOCALIZATION_PREFIX}$id.rules`,
    };
  }

  _onDataUpdated() {
    super._onDataUpdated();
    if (!this._data) return console.error('No data for rules');

    this._localizationKeysValues = {
      [this._eElementsTypes.EET_TEXT_CONTAINER]: { $id: this._data },
    }

    this._updateLocalizations();
  }

  get dataSelector() {
    return (data) => data.localizationTournamentId;
  }

  _getMarkup() {
    return `<div class="tournament_rules">
              <p id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXT_CONTAINER]}>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or- less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
            </div>`
  }
}
